/**
 * Figures any catalog string may quote, filled in the same way by the client's
 * t() and applyTranslations(), the server's catalogText() and its shell
 * localizer (2026-10-04).
 *
 * Six languages typed "193" into ten strings and "$0.61/GB" into one, so each
 * tariff or catalog change meant sixty edits (the 192 → 193 change in June
 * was one); and the server shell printed "© {year}" on every localized page,
 * because only the client knew the year.
 */
import { FAQ_MIN_TOPUP_USDT } from './faq-figures.js';
import { rateFloor } from './home-page.js';
export function catalogGlobals(countries, year = new Date().getFullYear()) {
    return {
        min_topup: `$${FAQ_MIN_TOPUP_USDT}`,
        countries: String(countries.length),
        floor_gb: rateFloor(countries).floorGb,
        year: String(year),
    };
}
/** `{name}` → value; unknown names stay as written. */
export function fillCatalogVars(s, vars) {
    return s.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
}
